import React from 'react'
import { shallow, mount } from 'enzyme'
import LinkVerification from '../subComponents/LinkVerification.jsx'

jest.mock('@fortressiq/fiq-ds', () => ({
  useNotification: () => ({
    addNotification: jest.fn(),
  }),
  useModal: () => ({
    addModal: jest.fn(),
    removeModal: jest.fn(),
  }),
  useFela: () => ({
    css: jest.fn(),
    theme: {
      'default-spacer-md': '16px',
      white: '#fff',
    },
  }),
  Button: ({ children, ...props }) => (
    <button type='button' {...props}>
      {children}
    </button>
  ),
  SwitchSection: ({ label, onSwitch, ...props }) => (
    <div {...props}>
      <label>{label}</label>
      <input type='checkbox' onChange={() => onSwitch({ SWITCH_STATE: !props.checked })} />
    </div>
  ),
  Typography: { Text: ({ textToCopy }) => <span>{textToCopy}</span> },
  theme: { 'default-spacer-md': '16px', white: '#fff' },
  Badge: ({ status }) => <span>{status}</span>,
  Popconfirm: ({ children, onConfirm }) => (
    <div>
      {children}
      <button type='button' onClick={onConfirm}>
        Confirm
      </button>
    </div>
  ),
}))

jest.mock('axios', () => ({
  get: jest.fn(() => Promise.resolve({ data: { msg: 'Success' } })),
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('lib/Api', () => ({
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

const props = {
  matchedId: { id: 35, url: 'http://example.com' },
  rowData: {
    id: 35,
    ipAddress: '172.21.0.1',
    active: false,
    verified: false,
    createdAt: '2025-05-05T05:53:27.570Z',
    updatedAt: '2025-05-05T05:53:40.978Z',
    verificationTokenExpiredAt: '2025-05-05T05:58:40.002Z',
    disabledAt: null,
    verifiedAt: '2025-05-05T05:53:40.978Z',
    error: null,
    tenantName: 'FortressIQ',
    createdByName: 'admin@fiq.ai',
    modifiedByName: 'admin@fiq.ai',
  },
  verificationLinksData: [],
  setVerificationLink: jest.fn(),
  handleReFetch: jest.fn(),
  whitelistStatus: true,
}

describe('Link Verify Button Component', () => {
  it('should match snapshot', () => {
    const wrapper = shallow(<LinkVerification {...props} />)
    expect(wrapper).toMatchSnapshot()
  })

  it('Get verify button should render without crashing', () => {
    const propsWithoutMatchId = {
      ...props,
      matchedId: false,
    }
    const wrapper = mount(<LinkVerification {...propsWithoutMatchId} />)
    const button = wrapper.find('.getVerifyLinkButton')
    button.at(0).prop('onClick')()
    expect(wrapper.find('.getVerifyLinkButton').exists()).toBe(true)
  })

  it('Click here to verify button should render without crashing', () => {
    const propsWithVerificationLinks = {
      ...props,
      verificationLinksData: [{ id: 35, url: 'http://example.com' }],
    }
    const wrapper = mount(<LinkVerification {...propsWithVerificationLinks} />)
    const button = wrapper.find('.getVerifyLinkButton')
    button.at(0).prop('onClick')()
    expect(wrapper.find('.getVerifyLinkButton').exists()).toBe(true)
  })

  it('Click here to verify button should render without crashing with locked True value', () => {
    const propsWithVerificationLinks = {
      ...props,
      rowData: {
        ...props.rowData,
        verified: false,
        locked: true,
      },
    }
    const wrapper = mount(<LinkVerification {...propsWithVerificationLinks} />)
    expect(wrapper.exists()).toBe(true)
  })

  it('Click here to verify button should render without crashing with verified True value', () => {
    const propsWithVerificationLinks = {
      ...props,
      rowData: {
        ...props.rowData,
        verified: true,
        locked: false,
      },
    }
    const wrapper = mount(<LinkVerification {...propsWithVerificationLinks} />)
    expect(wrapper.exists()).toBe(true)
  })
})
